var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"data"},[_c('img',{attrs:{"src":require("../assets/404.png"),"alt":"电子券不存在"}}),_c('p',[_vm._v("电子券不存在")])])])
}]

export { render, staticRenderFns }